/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import TOOLBOX_TABLE from "../toolbox/TOOLBOX_TABLE";
import SINI_DATA from "../sini_data/SINI_DATA";
import SINI_WRAPER from "./SINI_WRAPER";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { set_value_layer } from "../../App/actions/layerActions";

/*PICTURE*/
import icon_data from "../../Assets/svg/icon_data_new.svg";
import icon_sini from "../../Assets/svg/icon_sini.svg";
import icon_toolbox from "../../Assets/svg/icon_tool_new.svg";

/*FUNCTION*/

/*DATA*/

/*CONST*/
const tabs = [
  {
    value: "data",
    label: "DATA",
    icon: icon_data,
    alt: "Icon Data",
  },
  {
    value: "sini",
    label: "SINI",
    icon: icon_sini,
    alt: "Icon Sini",
  },
  {
    value: "toolbox",
    label: "TOOL",
    icon: icon_toolbox,
    alt: "Icon Toolbox",
  },
];

const SIDEBAR_CONTENT = ({
  layer,
  properties,
  set_value_properties,
  set_value_layer,
}) => {
  const { statistic_mode } = layer;
  const { sidebar_height, is_mobile } = properties;

  let max_height_css;
  if (sidebar_height === "pc") {
    max_height_css = `calc(100vh - 101px)`;
  } else {
    max_height_css = `calc(${sidebar_height}px - 60px)`;
  }

  let final_tabs = tabs;
  let sidebar_content;

  if (statistic_mode === "toolbox") {
    sidebar_content = <TOOLBOX_TABLE />;
  } else if (statistic_mode === "sini") {
    sidebar_content = <SINI_WRAPER />;
  } else {
    sidebar_content = <SINI_DATA />;
  }

  const setStatisticModeFunc = (event, value) => {
    if (is_mobile) {
      set_value_properties({
        key: "sidebar_right_status",
        value: true,
      });
    }
    set_value_layer({
      key: "statistic_mode",
      value: value,
    });
  };

  return (
    <main>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          borderBottom: "1px solid #ddd",
        }}
      >
        {final_tabs.map((tab) => {
          const isActive = statistic_mode === tab.value;
          return (
            <div
              key={tab.value}
              onClick={() => setStatisticModeFunc(null, tab.value)}
              data-mapid="clickTabIcon"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "8px 16px",
                minHeight: "30px",
                borderBottom: isActive
                  ? "3px solid #000"
                  : "3px solid transparent",
                color: isActive ? "#000" : "#555",
                fontWeight: isActive ? "bold" : "normal",
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div
                className="outline_grey"
                style={{
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "15px",
                  marginRight: "8px",
                  backgroundColor: "#fff",
                }}
              >
                <img
                  src={tab.icon}
                  alt={tab.alt}
                  style={{ width: "20px", height: "20px" }}
                />
              </div>
              <span>{tab.label}</span>
            </div>
          );
        })}
      </div>

      <section
        style={{
          padding: "0px 10px 0px 10px",
          overflowY: "auto",
          maxHeight: max_height_css,
          marginTop: "10px",
        }}
      >
        <div
          style={{
            width: "100%",
            marginBottom: "150px",
          }}
        >
          {sidebar_content}
        </div>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_properties,
  set_value_layer,
})(SIDEBAR_CONTENT);
